import { useDeferredValue, useState } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import { AHText, Box } from "arkh";
import { ProductInfoExpanded } from "../Product/ProductInfoExpanded";

import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { withWebModalStack } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModalStack";
import { ScrollView, View } from "react-native";
import { ProductAPIPlaygroundQuery } from "./__generated__/ProductAPIPlaygroundQuery.graphql";
import { Image } from "expo-image";

import { HeaderButton } from "../../components";
import MyEditor from "./Editor";

const defaultL = `
{
  "data": {
    "stock": {
      "store": {
        "quantity": 5
      },
      "otherLocations": [
        {
          "name": "Distribution Center",
          "quantity": 5
        }
      ]
    },
    "regularPrice": {
      "currency": "SEK",
      "value": 129
    },
    "specialPrices": [
      {
        "price": {
          "currency": "SEK",
          "value": 89
        },
        "startAt": "2024-10-10",
        "endAt": "2024-12-10"
      }
    ],
    "promotions": true
  }
}
`;
function ProductPreviewC() {
  const [data, setData] = useState<string | null>(defaultL);

  const d = useDeferredValue(data);

  return (
    <Box style={{ flexDirection: "row", flex: 1 }}>
      <Box style={{ width: 500, height: "100%" }} space="medium">
        <MyEditor
          value={d}
          onChange={setData}
          schemaUri="https://api.storesprint.app/schemas/product-store-info.json"
        />
      </Box>
      <LazyQueryNetworkBoundrary>
        {(fk) => <Preview data={d} />}
      </LazyQueryNetworkBoundrary>
    </Box>
  );
}
export const ProductAPIPlayground = withWebModalStack(ProductPreviewC, false, {
  width: 900,
});

function Preview(props: { data: string | null }) {
  const product = useLazyLoadQuery<ProductAPIPlaygroundQuery>(
    graphql`
      query ProductAPIPlaygroundQuery($data: String) {
        storeProductPreview(data: $data) {
          product {
            ...ProductInfoExpanded_StoreProduct
          }
          errors
        }
      }
    `,
    {
      data: props.data,
    }
  );

  return (
    <Box
      style={{
        flexDirection: "column",
        height: "100%",
        justifyContent: "space-between",
      }}
    >
      <Box spaceTop="medium">
        <View
          style={{
            width: 380,
            height: 600,
          }}
        >
          <Image
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: 380,
              height: 700,
            }}
            source={require("./Zebra.png")}
          />
          <Box
            style={{
              height: 472,
              width: 265,
              top: 128,
              overflow: "hidden",

              alignSelf: "center",
            }}
            color="surface"
            borderColor="darkerText"
            cornerRadius="small"
          >
            <Box color="surface">
              <HeaderButton type="CLOSE" />
            </Box>
            <ScrollView>
              {product.storeProductPreview?.product ? (
                <ProductInfoExpanded
                  product={product.storeProductPreview.product}
                />
              ) : null}
            </ScrollView>
          </Box>
        </View>
      </Box>
      {product.storeProductPreview?.errors ? (
        <Box space="medium" color="negative" style={{ position: "absolute" }}>
          <AHText color="text-inverted">
            {product.storeProductPreview?.errors}
          </AHText>
        </Box>
      ) : null}
    </Box>
  );
}
